import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import '@nordinsight/implant-core/styles.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthContextProvider } from './store/auth-context';

// Suppress benign ResizeObserver loop error caused by Radix UI popovers
// repositioning during layout changes in the same animation frame.
window.addEventListener('error', (e) => {
    if (
        e.message ===
        'ResizeObserver loop completed with undelivered notifications.'
    ) {
        e.stopImmediatePropagation();
    }
});

let root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
    // <React.StrictMode>
    <AuthContextProvider>
        <App />
    </AuthContextProvider>
    // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
